export default "__VITE_ASSET__9256970e__"